"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlProcessingPaymentsSerialization = void 0;
const PaymentTerminalControlOfflinePayloadSerialization_1 = require("./PaymentTerminalControlOfflinePayloadSerialization");
const PaymentTransactionSerialization_1 = require("./PaymentTransactionSerialization");
class PaymentTerminalControlProcessingPaymentsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.offline_payloads = entity.offline_payloads?.map((field) => field
            ? JSON.parse(PaymentTerminalControlOfflinePayloadSerialization_1.PaymentTerminalControlOfflinePayloadSerialization.serialize(field))
            : undefined);
        copy.pending_captures = entity.pending_captures?.map((field) => field
            ? JSON.parse(PaymentTransactionSerialization_1.PaymentTransactionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.offline_payloads = entity.offline_payloads?.map((field) => field
            ? PaymentTerminalControlOfflinePayloadSerialization_1.PaymentTerminalControlOfflinePayloadSerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.pending_captures = entity.pending_captures?.map((field) => field
            ? PaymentTransactionSerialization_1.PaymentTransactionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.PaymentTerminalControlProcessingPaymentsSerialization = PaymentTerminalControlProcessingPaymentsSerialization;
